export const metricTypes: any = {
    webpageviews: { title: "Web page views", metric: "web" },
    apppageviews: { title: "App page views", metric: "app" },
    pageviews: { title: "Page views", metric: "total" },
    videoPageViews: { title: "Video page views", metric: "video" },
    conversion: { title: "Conversion", metric: "conversion" },
    totalReadingTime: { title: "Total Reading time (hrs)", metric: "totalReadingTime" },
};

export const RANGE_EXTEND = 5;

export const RedArrow = <span style={{ color: "red" }}>▼</span>;
export const GreenArrow = <span style={{ color: "green" }}>▲</span>;